import * as navigation from "./categories/navigation";
import * as signUp from "./categories/signUp";

// See: https://martinfowler.com/articles/domain-oriented-observability.html

export const track = {
  navigation,
  signUp,
};
